<script lang="ts">
    import type { OrganizationData } from "@anyways-open/identity-api-client";
    import { onMount } from "svelte";
    import { Link } from "svelte-navigator";
    import { appManager } from "../AppManagerStore";
    import Footer from "../footer/Footer.svelte";
    import Navbar from "../header/Navbar.svelte";

    let data: OrganizationData[] = [];

    onMount(async () => {
        const accessToken = await $appManager.Authenticator.getAccessToken();
        data =
            (
                await $appManager.IdentityApi.getOrganizations({
                    accessToken: accessToken,
                })
            )?.organizations ?? [];
    });
</script>

<Navbar isDark={false} isFluid={false} />

<main class="pb-8 pb-md-11 mt-6">
    <div class="container-md">
        <div class="row">
            {#each data as organization}
                <div class="col-6">
                    {organization.name}
                </div>
                <div class="col-auto ms-auto">
                    <Link
                        class="btn btn-xs btn-primary"
                        to="/settings/organizations/{organization.id}">
                        Manage
                    </Link>
                </div>
            {/each}
        </div>
    </div>
</main>

<Footer />
